/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";
import * as constants from "../../constants";

const editExperienceLogic = createLogic({
	type: ActionTypes.EDIT_EXPERIENCE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/experiences/${action.experienceId}`, action.experience)
					.then(() => {
						//TODO: dispatch action for stopping loader
						dispatch(ExperiencesActions.editExperienceSuccess());
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(ExperiencesActions.editExperienceFail(error));
						done();
					});
			});
	},
});

export default [editExperienceLogic];
